<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.8932 12L23.815 1.07816C24.0617 0.831527 24.0617 0.43162 23.815 0.184988C23.5683 -0.0616431 23.1685 -0.0616825 22.9218 0.184988L12 11.1068L1.07816 0.185028C0.831528 -0.0616431 0.43162 -0.0616431 0.184988 0.185028C-0.0616431 0.431699 -0.0616825 0.831567 0.184988 1.0782L11.1068 12L0.185028 22.9219C-0.0616431 23.1685 -0.0616431 23.5684 0.185028 23.815C0.308344 23.9383 0.469949 24 0.631594 24C0.793238 24 0.954843 23.9383 1.07816 23.815L12 12.8932L22.9219 23.815C23.0452 23.9383 23.2068 24 23.3684 24C23.5301 24 23.6917 23.9383 23.815 23.815C24.0617 23.5684 24.0617 23.1684 23.815 22.9218L12.8932 12Z"
    fill="currentColor"
  />
</svg>
